import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgClose = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 25,
	viewBox: "0 0 24 25",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		d: "M18.3007 6.21C17.9107 5.82 17.2807 5.82 16.8907 6.21L12.0007 11.09L7.1107 6.2C6.7207 5.81 6.0907 5.81 5.7007 6.2C5.3107 6.59 5.3107 7.22 5.7007 7.61L10.5907 12.5L5.7007 17.39C5.3107 17.78 5.3107 18.41 5.7007 18.8C6.0907 19.19 6.7207 19.19 7.1107 18.8L12.0007 13.91L16.8907 18.8C17.2807 19.19 17.9107 19.19 18.3007 18.8C18.6907 18.41 18.6907 17.78 18.3007 17.39L13.4107 12.5L18.3007 7.61C18.6807 7.23 18.6807 6.59 18.3007 6.21Z",
		fill: "#282828"
	})]
});
const ForwardRef = forwardRef(SvgClose);
export { ForwardRef as ReactComponent };
